import {Hide, Space, VStack} from 'platform/foundation';

import {ReactNode, Children, cloneElement, isValidElement, ReactElement} from 'react';

export const ComparisonBlock = ({
  children,
  hasNoSpace,
}: {
  children: ReactNode;
  hasNoSpace?: boolean;
}) => (
  <VStack spacing={0}>
    {Children.map(children, (child, index) =>
      isValidElement(child) ? cloneElement(child as ReactElement<{index?: number}>, {index}) : child
    )}
    <Hide when={hasNoSpace}>
      <Space vertical={6} />
    </Hide>
  </VStack>
);
